import React, { useEffect, useState } from 'react';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import TableContainer from '@mui/material/TableContainer';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import Box from '@mui/material/Box';
import axios from 'axios';
import DownloadIcon from '@mui/icons-material/Download';
import Typography from '@mui/material/Typography';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import { useForm } from 'react-hook-form';
import { Button, IconButton, TextField } from '@mui/material';
import { styled } from '@mui/system';

import OrderCancel from 'components/Coupon/OrderCancel';

export default function TaxBillDetail(props) {
  const { open, handleClose, getDataList, page, companyId, orderId, prgStepItems } = props;

  const [taxBillInfo, setTaxBillInfo] = useState({});
  const [openInvoice, setOpenInvoice] = useState(false);
  const [openCancel, setOpenCancel] = useState(false);
  const [openTax, setOpenTax] = useState(false);
  const [selected, setSelected] = useState({});

  const deposit = async (evt) => {
    if (window.confirm('입금 완료하시겠습니까?')) {
      await axios
        .patch(`/api/coupon/deposit/${orderId}`)
        .then((response) => {
          alert(response.data.message);
          getDataList(page);
          handleClose();
        })
        .catch((error) => {
          alert(error.response.data.message);
        });
    }
  };

  const handleClickCancel = async (e) => {
    e.stopPropagation();
    setSelected(taxBillInfo);
    setOpenCancel(true);
  };

  const handleCloseCancel = (e) => {
    setOpenCancel(false);
    getTaxBillInfo();
  };

  const handleClickOpenTax = (e) => {
    setOpenTax(true);
  };

  const handleCloseTax = (e) => {
    setOpenTax(false);
    getTaxBillInfo();
  };

  const getTaxBillInfo = async () => {
    try {
      const response = await axios.get(`/api/coupon/order-tax-bill/${orderId}`);
      if (response?.data) {
        setTaxBillInfo(response.data?.couponOrder);
      }
    } catch (e) {
      console.log('세금계산서 정보를 불러오지 못했습니다.');
    }
  };

  const fileDown = async (params) => {
    const { fileName, orderNo } = params;
    const response = await axios.get(`/api/file-smtp`, { params: { fileName, orderNo }, responseType: 'blob' });
    if (response.data.error) {
      console.error(response.data.error);
      alert('다운로드 실패!');
    } else {
      const fileURL = window.URL.createObjectURL(new Blob([response.data]));
      const fileLink = document.createElement('a');
      fileLink.href = fileURL;
      const fileOriginName = response.headers['content-disposition'].split('filename=')[1];
      fileLink.setAttribute('download', fileOriginName.replace(/"/g, ''));
      fileLink.setAttribute('target', '_blank');
      document.body.appendChild(fileLink);
      fileLink.click();
      fileLink.remove();
    }
  };

  /**
   * 사업자등록증 다운로드
   * @param {*} e
   */
  const handleClickDownloadRegist = async (e) => {
    const fileName = taxBillInfo?.fileName;
    const orderNo = taxBillInfo?.orderNo;
    await fileDown({ fileName, orderNo });
  };

  useEffect(() => {
    if (open && orderId) {
      getTaxBillInfo();
    }
  }, [open, orderId]);

  useEffect(() => {
    if (!openInvoice && open && orderId) {
      getTaxBillInfo();
    }
  }, [openInvoice]);

  return (
    <Dialog open={open} onClose={handleClose} aria-labelledby="draggable-dialog-title" maxWidth={'lg'}>
      <DialogTitle id="draggable-dialog-title">사용권구매 진행상황</DialogTitle>
      <DialogContent dividers sx={{ height: 600 }}>
        <Box sx={{ m: 4 }}>
          <Typography>세금계산서 신청 내역</Typography>
          <TableContainer component={'div'}>
            <Table>
              <TableBody>
                <TableRow>
                  <TableCell>주문번호</TableCell>
                  <TableCell>{taxBillInfo?.orderNo}</TableCell>
                  <TableCell>회사명</TableCell>
                  <TableCell>{taxBillInfo?.acCompanyName}</TableCell>
                  <TableCell>사업자 등록번호</TableCell>
                  <TableCell>{taxBillInfo?.acCompanyNo}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>이름</TableCell>
                  <TableCell>{taxBillInfo?.acUserName}</TableCell>
                  <TableCell>전화번호</TableCell>
                  <TableCell>{taxBillInfo?.accountantPhone}</TableCell>
                  <TableCell>이메일</TableCell>
                  <TableCell>{taxBillInfo?.accountantEmail}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>사업자등록증</TableCell>
                  {taxBillInfo?.isFileRegist ? (
                    <TableCell>
                      {taxBillInfo?.isFileRegist && `${taxBillInfo?.fileNameOrigin}`}
                      <IconButton aria-label="down" onClick={handleClickDownloadRegist}>
                        <DownloadIcon />
                      </IconButton>
                    </TableCell>
                  ) : (
                    <TableCell>-</TableCell>
                  )}
                  <TableCell>사용권수량</TableCell>
                  <TableCell>{taxBillInfo?.quantity}</TableCell>
                  <TableCell>잔여수량</TableCell>
                  <TableCell>{taxBillInfo?.residualQuantity === null ? '생성된 사용권 없음' : Number(taxBillInfo?.residualQuantity)}</TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>
        </Box>
        {(taxBillInfo?.quantity === taxBillInfo?.residualQuantity || taxBillInfo?.residualQuantity === null) && (
          <Box sx={{ m: 4 }} display="flex">
            {!taxBillInfo?.cancelReqAt ? (
              <Button variant="contained" color="error" onClick={handleClickCancel} sx={{ width: 160 }}>
                주문취소
              </Button>
            ) : (
              <Button variant="contained" sx={{ width: 160, pointerEvents: 'none' }} color="info">
                {taxBillInfo?.prgStepCd === 'CANCEL_CMPT' ? '주문취소완료' : '주문취소 진행중..'}
              </Button>
            )}
            {taxBillInfo.cancelReqAt && <Typography sx={{ ml: 2, mt: 1 }}>* 취소사유 : {taxBillInfo?.cancelReason}</Typography>}
          </Box>
        )}
        <Box sx={{ mx: 4 }} display="flex" justifyContent="center">
          <Breadcrumbs separator={<NavigateNextIcon fontSize="large" />} aria-label="breadcrumb">
            {prgStepItems.map((item) => {
              const prgStepCd = item?.cdVal;
              const activeCode = taxBillInfo?.prgStepCd;
              if (prgStepCd === '001' && activeCode === '001') {
                return <ActiveBtn prgStepNm="주문요청" label="주문요청" onClick={handleClickOpenTax} activeStep={activeCode} prgStepCd={prgStepCd} companionAt={taxBillInfo?.companionAt} />;
              }
              if (prgStepCd === '002' && activeCode !== '001') {
                return <ActiveBtn prgStepNm="주문확인" label={activeCode === '002' ? '주문확인중' : '주문확인'} activeStep={activeCode} prgStepCd={prgStepCd} isEvent={true} />;
              }
              if (prgStepCd === '100') {
                return (
                  <ActiveBtn
                    prgStepNm="세금계산서 발행요청"
                    label={
                      activeCode === '100' ? (
                        <>
                          세금계산서 <br /> 발행중
                        </>
                      ) : (
                        <>
                          세금계산서 <br /> 발행
                        </>
                      )
                    }
                    activeStep={activeCode}
                    prgStepCd={prgStepCd}
                    isEvent={true}
                  />
                );
              }
              if (prgStepCd === '200') {
                return <ActiveBtn prgStepNm="입금대기중" label="입금완료" onClick={deposit} activeStep={activeCode} prgStepCd={prgStepCd} companionAt={taxBillInfo?.companionAt} />;
              }
              if (prgStepCd === '201') {
                return <ActiveBtn prgStepNm="입금완료" label={activeCode === '201' ? '입금확인중' : '입금확인'} activeStep={activeCode} prgStepCd={prgStepCd} isEvent={true} />;
              }
              if (prgStepCd === '800') {
                return <ActiveBtn prgStepNm="코드발급완료" label="코드발급완료" activeStep={activeCode} prgStepCd={prgStepCd} isEvent={true} />;
              }
            })}
          </Breadcrumbs>
        </Box>
        {taxBillInfo?.companionAt && (
          <Box sx={{ m: 4 }} display="flex">
            <Typography sx={{ ml: 2, mt: 1 }}>* 반려사유 : {taxBillInfo?.companionReason}</Typography>
          </Box>
        )}
        <OrderCancel pDatas={selected} open={openCancel} handleClose={handleCloseCancel} getDataList={getDataList} />
        {openTax && <UpdateForm pDatas={taxBillInfo} open={openTax} onClose={handleCloseTax} getDataList={getDataList} getTaxBillInfo={getTaxBillInfo} />}
      </DialogContent>
      <DialogActions>
        <Button variant="outlined" color="success" onClick={handleClose}>
          닫기
        </Button>
      </DialogActions>
    </Dialog>
  );
}

const ActiveBtn = (props) => {
  const { onClick, activeStep, prgStepCd, label, isEvent, companionAt } = props;

  /**
   * 현재 단계 및 이전 단계 활성화. 이후 단계는 비활성화
   * @param {*} activeStep 현재 진행단계
   * @param {*} currentPrgStep 활성화를 위한 이전단계 코드
   * @returns
   */
  const isDisabled = (activeStep, prevPrgStep) => {
    let isVisible = true;
    if (Number(activeStep) >= Number(prevPrgStep)) {
      isVisible = false;
    }
    return isVisible;
  };

  /**
   * 현재 단계 및 이전 단계 활성화. 이후 단계는 비활성화
   * @param {*} activeStep 현재 진행단계
   * @param {*} currentPrgStep 버튼클릭 활성화를 위한 진행단계코드
   * @returns
   */
  const getStyle = (activeStep, prevPrgStep) => {
    const isActiveStep = Number(activeStep) === Number(prevPrgStep);
    let props = { sx: { width: 160, height: 100, pointerEvents: 'none' }, color: 'info' };
    if (isActiveStep && !isEvent) {
      props = { sx: { width: 160, height: 100 }, color: 'primary' };
    }
    if (companionAt) {
      props = { ...props, color: 'warning' };
    }
    return props;
  };

  return (
    <Button variant="contained" onClick={onClick} disabled={isDisabled(activeStep, prgStepCd)} {...getStyle(activeStep, prgStepCd)}>
      {label}
    </Button>
  );
};

const StyledInput = styled('input')({
  display: 'none'
});

const UpdateForm = ({ pDatas, open, onClose, getDataList, getTaxBillInfo }) => {
  const {
    register,
    handleSubmit,
    formState: { errors }
  } = useForm({
    defaultValues: {
      acUserName: pDatas?.acUserName,
      acCompanyName: pDatas?.acCompanyName,
      accountantPhone: pDatas?.accountantPhone,
      accountantEmail: pDatas?.accountantEmail,
      acCompanyNo: pDatas?.acCompanyNo
    }
  });
  const [selectedFile, setSelectedFile] = useState(null);
  const [fileName, setFileName] = useState(pDatas?.fileNameOrigin);

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    setSelectedFile(file);
    setFileName(file.name);
  };

  const couponOrder = async (data) => {
    let formData = new FormData();
    const config = {
      headers: { 'content-type': 'multipart/form-data' }
    };

    formData.append('orderNo', data?.orderNo);
    formData.append('acUserName', data?.acUserName);
    formData.append('acCompanyName', data?.acCompanyName);
    formData.append('accountantPhone', data?.accountantPhone);
    formData.append('accountantEmail', data?.accountantEmail);
    formData.append('acCompanyNo', data?.acCompanyNo);
    if (data?.companionAt) formData.append('companionAt', data?.companionAt);
    if (selectedFile) formData.append('file', selectedFile);

    return await axios.patch(`/api/coupon/order/${data?.orderId}`, formData, config);
  };

  const onSubmit = (data) => {
    if (window.confirm('세금계산서 정보를 변경하시겠습니까?')) {
      let insertParams = { ...data, orderId: pDatas?.id, orderNo: pDatas?.orderNo };
      if (pDatas?.companionAt) insertParams = { ...insertParams, companionAt: pDatas?.companionAt };
      couponOrder(insertParams)
        .then((response) => {
          alert(response.data.message);
          getDataList();
          getTaxBillInfo();
          onClose();
        })
        .catch((error) => {
          alert(error.response.data.message);
          console.log(error.response);
        });
    }
  };

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>세금계산서 요청 정보</DialogTitle>
      <form onSubmit={handleSubmit(onSubmit)}>
        <DialogContent>
          <TextField
            {...register('acCompanyName', { required: '회사명을 입력하세요.' })}
            name="acCompanyName"
            label="회사명"
            error={!!errors.acCompanyName}
            helperText={errors.acCompanyName && errors.acCompanyName.message}
            margin="normal"
            variant="outlined"
            fullWidth
          />
          <TextField
            {...register('acUserName', { required: '세금계산서를 받을 담당자명을 입력하세요.' })}
            name="acUserName"
            label="담당자명"
            error={!!errors.acUserName}
            helperText={errors.acUserName && errors.acUserName.message}
            margin="normal"
            variant="outlined"
            fullWidth
          />
          <TextField
            {...register('accountantPhone', { required: '세금계산서를 받을 담당자 전화번호를 입력하세요.' })}
            name="accountantPhone"
            label="전화번호"
            error={!!errors.accountantPhone}
            helperText={errors.accountantPhone && errors.accountantPhone.message}
            margin="normal"
            variant="outlined"
            fullWidth
          />
          <TextField
            {...register('accountantEmail', { required: '세금계산서를 받을 이메일을 입력하세요.' })}
            name="accountantEmail"
            label="수신 이메일"
            error={!!errors.accountantEmail}
            helperText={errors.accountantEmail && errors.accountantEmail.message}
            margin="normal"
            variant="outlined"
            fullWidth
          />
          <TextField
            {...register('acCompanyNo', { required: '사업자 등록번호를 입력하세요.' })}
            name="acCompanyNo"
            label="사업자 등록번호"
            error={!!errors.acCompanyNo}
            helperText={errors.acCompanyNo && errors.acCompanyNo.message}
            margin="normal"
            variant="outlined"
            fullWidth
          />
          <TextField
            label="사업자등록증"
            variant="outlined"
            value={fileName}
            fullWidth
            readOnly
            sx={{ mt: 2 }}
            InputProps={{
              endAdornment: (
                <>
                  <StyledInput accept=".pdf" id="file-upload" multiple type="file" {...register('file', {})} onChange={handleFileChange} />
                  <label htmlFor="file-upload">
                    <Button variant="contained" component="span" sx={{ width: 120 }}>
                      파일재첨부
                    </Button>
                  </label>
                </>
              )
            }}
            error={Boolean(errors.file)}
            helperText={errors.file && '사업자등록증을 등록하세요'}
          />
        </DialogContent>
        <DialogActions sx={{ m: 2 }}>
          <Button variant="contained" type="submit">
            변경
          </Button>
          <Button variant="outlined" onClick={onClose}>
            취소
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  );
};
